(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always' || this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      // --header-height WAS THE HEIGHT THE HEADER HAD AT PAGE LOAD, and it kept
      // that value for the life of the page. On this store the header is
      // `data-sticky-type="reduce-logo-size"`, so it SHRINKS the moment the
      // reader scrolls past it -- 199.8px down to 171.5px, measured on the live
      // collection page. The variable stayed at 200.
      //
      // Anything docking to it therefore docks 28.5px too low. The collection
      // filter band pins at `top: var(--header-height)`, so a 28.5px strip of
      // the product grid scrolls between the bottom of the header and the top
      // of the band, permanently, at every scroll position past the header --
      // which is the band reading as floating over the grid rather than docked
      // under the header. `base.css`'s `.shopify-section-header-hidden` offsets
      // by the same variable and is wrong by the same amount.
      //
      // The two existing triggers cannot catch it: `connectedCallback` runs
      // before any scroll, and the 990px media query fires on a breakpoint
      // crossing, not on the class change that resizes the logo.
      //
      // A ResizeObserver is the trigger that matches what the value means --
      // "how tall is the header now" -- rather than a second guess at when it
      // might change. NO LOOP: nothing that reads --header-height feeds back
      // into the header's own height (a sticky `top` offset and a translate
      // offset), and setHeaderHeight writes only when the value differs, so a
      // resize that rounds to the same pixel does not touch the DOM at all.
      if (window.ResizeObserver) {
        new ResizeObserver(() => this.setHeaderHeight()).observe(this.header);
      }

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      };

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      // Written only when it CHANGES. The ResizeObserver above fires on every
      // sub-pixel reflow, and an unconditional style write on each one is a
      // style recalculation per frame during a scroll for a value that has not
      // moved.
      const height = `${this.header.offsetHeight}px`;
      if (document.documentElement.style.getPropertyValue('--header-height') === height) return;
      document.documentElement.style.setProperty('--header-height', height);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();
})();
